export const mapFormToShiftTemplate = (values: any) => {
    return {
        ...values,
        position: values?.position?.value || '',
        durationHours: Number(values.durationHours)
    };
};

export const mapShiftTemplateToForm = (item: any) => {
    return {
        name: item?.name || '',
        startTime: item?.startTime ? item.startTime.substring(0, 5) : '',
        endTime: item?.endTime ? item.endTime.substring(0, 5) : '',
        durationHours: item?.durationHours || '',
        position: item?.position || { value: '', label: '' },
    };
};
